var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "kcb-cert"
  }, [_vm.show ? _c('div', {
    staticClass: "kcb-cert__screen"
  }, [_c('iframe', {
    staticClass: "kcb-cert__iframe",
    attrs: {
      "src": _vm.src,
      "frameborder": "0",
      "scrolling": "yes"
    }
  }), _c('button', {
    staticClass: "kcb-cert__close",
    attrs: {
      "type": "button",
      "aria-label": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._t("activator", null, {
    "on": {
      click: _vm.open
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }